const initialState = {
    user: null, // Store user information when authenticated
    isAuthenticated: false,
};

const contactReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'USER_QUERY':
            return {
                ...state,
                request: action.payload,
                isAuthenticated: true,
            };
        default:
            return state;
    }
};

export default contactReducer;
